const BaneseValidatorRules = {

  changeAgency: agency => {
    return agency.substr(agency.length - 2)
  },

  pesos: [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5, 6, 7, 8]
}

const BaneseValidator = {

  agencyNumberIsValid: function(agencyNumber) {
    return !(agencyNumber == "" || agencyNumber == undefined)
  },

  agencyCheckNumberIsValid: function(agencyCheckNumber) {
    return true
  },

  accountNumberIsValid: function(accountNumber) {
    return ((accountNumber || "").length === this.accountNumberLength()) && (/^[0-9]{1,12}$/.test(accountNumber)) && (parseInt(accountNumber) > 0)
  },

  accountCheckNumberIsValid: function(accountCheckNumber) {
    return !(accountCheckNumber == "" || accountCheckNumber == undefined)
  },

  agencyCheckNumberMatch: function(bankAccount) {
    return true;
  },

  accountCheckNumberMatch: function(bankAccount) {

    let agency = BaneseValidatorRules.changeAgency(bankAccount.agencyNumber)
    let agencyAndbankAccount = agency + '' + bankAccount.accountNumber
    let arrNumbers = agencyAndbankAccount.split('')
    let digit = parseInt(bankAccount.accountCheckNumber)

    let soma = arrNumbers.reverse()
    .map((n, index) => parseInt(n) * BaneseValidatorRules.pesos[index])
    .reduce((soma, number) => soma + number, 0)

    let resto = soma % 11

    if(resto == 1 || resto == 0) return digit === 0

    return digit == 11 - resto

  },

  agencyNumberMsgError: function() {
    return "Agência inválida";
  },

  agencyCheckNumberMsgError: function() {
    return "Dígito da agência inválido";
  },

  accountNumberMsgError: function(length) {
    return "A conta corrente deve conter " + length + " números. Complete com zeros a esquerda se necessário.";
  },

  accountNumberLength: function() { return 6; }

};

module.exports = BaneseValidator;



// WEBPACK FOOTER //
// ./src/assets/js/arautos-bank-validator/banco-regional-brasilia.js